import React from 'react';
import RynoLogo from '../../assets/images/logo.png';
import BaseLabelText from './label-text';
import BgPattern from '../../assets/images/bg-pattern.png';

// Define props interface
interface InvoiceProps {
  transaction: any;
}

const Invoice: React.FC<InvoiceProps> = ({ transaction }) => {
  if (!transaction) return null; // Prevent rendering when no transaction is passed

  return (
    <div
    className="py-10 px-12 bg-white rounded-xl border border-[#F1F2F4] shadow-sm h-full w-full"
    style={{
      backgroundImage: `url(${BgPattern})`,
      backgroundSize: '200px 200px',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
    }}
  >
    {/* Header */}
    <div className="flex justify-between items-center pb-4 border-b border-[#F1F2F4]">
      <img src={RynoLogo} alt="logo" className="w-24" />
      <p className="text-[#687588] font-light ">PAYMENT RECEIPT</p>
    </div>

    {/* Transaction Details */}
    <div className="mt-6 space-y-4">
      <BaseLabelText label="Date" value={new Date(transaction.transactionDate).toLocaleDateString()} type="horizontal" />
      <BaseLabelText label="Time" value={new Date(transaction.transactionDate).toLocaleTimeString()} type="horizontal" />
      <BaseLabelText label="Ref No." value={transaction.transactionRef} type="horizontal" />
      <BaseLabelText label="Status" value={transaction.transactionStatus} type="horizontal" />
    </div>

    {/* Border bottom after Status */}
    <div className="border-b border-[#F1F2F4] my-4"></div>

    {/* Payment Details */}
    <p className="font-bold text-lg mb-4">Payment Details</p>
    <div className="space-y-4">
      <BaseLabelText label="Amount" value={`$${transaction.sentAmount.toLocaleString()}`} type="horizontal" />
      <BaseLabelText label="Converted Amount" value={`₦${transaction.expectedAmount.toLocaleString()}`} type="horizontal" />
      <BaseLabelText label="Exchange Rate" value={transaction.rate.toString()} type="horizontal" />
    </div>

    {/* Border bottom after Payment Details */}
    <div className="border-b border-[#F1F2F4] my-4"></div>

    {/* Recipient Details */}
    <p className="font-bold text-lg mb-4">Recipient Details</p>
    <div className="space-y-4">
      <BaseLabelText label="Name" value={transaction.transactionDetail?.customerName || 'N/A'} type="horizontal" />
      <BaseLabelText label="Bank" value={transaction.transactionDetail?.bankName || 'N/A'} type="horizontal" />
      <BaseLabelText label="Account" value={transaction.transactionDetail?.accountNumber || 'N/A'} type="horizontal" />
      <BaseLabelText label="Description" value={transaction.paymentPurpose || 'N/A'} type="horizontal" />
    </div>
  </div>
  );
};

export default Invoice;
